import { CountryCode } from "./country-code.js";
import { CountryFlag } from "./country-flag.js";
import { DocumentIdLength } from "./document-id-length.js";
import { DocumentTypeByCountry } from "./document-type.js";
import { PhoneNumberLength } from "./phone-number-length.js";
import { PhoneNumberPrefix } from "./phone-number-prefix.js";
import { TimeZone } from "./time-zone.js";
//#region src/domain/i18n/country-factory.ts
var createCountryFromCountryCode = (countryCode) => {
	return {
		countryCode: CountryCode[countryCode],
		countryFlag: CountryFlag[countryCode],
		phoneNumberPrefix: PhoneNumberPrefix[countryCode],
		phoneNumberLength: PhoneNumberLength[countryCode],
		documentIdLength: DocumentIdLength[countryCode],
		documentType: DocumentTypeByCountry[countryCode],
		timeZone: TimeZone[countryCode],
		flag: CountryFlag[countryCode]
	};
};
//#endregion
export { createCountryFromCountryCode };

//# sourceMappingURL=country-factory.js.map